import { ChangeDetectionStrategy, Component } from '@angular/core';

@Component({
    selector: 'dmv-pub-page-bad-request',
    templateUrl: './page-bad-request.component.html',
    changeDetection: ChangeDetectionStrategy.OnPush,
    standalone: false
})
export class PageBadRequestComponent {

}
